<template>
  <ModalPaymentMethod v-if="modalShowPaymentMethod" @closeModal="closeModal" :paymentMethod="selectedPaymentMethod" />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ 'hidden': !isBlur }"></div>
  <div class="flex mb-8 justify-between">
    <!-- <h2 class="text-xl font-medium me-3">Metode Pembayaran</h2> -->
    <AddButton to_url="#" button_text="+ Tambah Metode Pembayaran" button_class="text-sm py-2" @click="showModal" />
  </div>
  <div>
    <TableComponent>
      <TableHead>
        <TableRow>
          <TableHeadCell>No</TableHeadCell>
          <TableHeadCell>Metode Pembayaran</TableHeadCell>
          <TableHeadCell>Masuk Cash Register</TableHeadCell>
          <TableHeadCell>Action</TableHeadCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow v-if="allPaymentMethods.length == 0">
          <TableCell colspan="3">Belum ada data</TableCell>
        </TableRow>
        <TableRow v-else v-for="(paymentMethod, index) in allPaymentMethods" :key="paymentMethod.id">
          <TableCell>{{ index + 1 }}</TableCell>
          <TableCell>{{ paymentMethod.name }}</TableCell>
          <TableCell>
            <span :class="{
              'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300': paymentMethod.is_cash_register == true,
              'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300': paymentMethod.is_cash_register == false
            }" class="px-2 py-1 rounded-full text-xs font-medium">
              {{ paymentMethod.is_cash_register ? "Ya" : "Tidak" }}
            </span>
          </TableCell>
          <TableCell>
            <div class="flex gap-1">
            <button v-if="!isHutang(paymentMethod) && !isCash(paymentMethod)" :id="'edit-data-' + paymentMethod.id" @click="editPaymentMethod(paymentMethod)"
              class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
              <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
            </button>
            <button v-if="!isHutang(paymentMethod) && !isCash(paymentMethod)" :id="'delete-data-' + paymentMethod.id" @click="deletePaymentMethod(paymentMethod)"
              class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
              <TrashIcon class="h-4 w-4 text-gray-500 group-hover:text-red-700" />
            </button>
          </div>
          </TableCell>
        </TableRow>
      </TableBody>
    </TableComponent>
    <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
  </div>
</template>

<script>
import ModalPaymentMethod from '@/components/modals/ModalPaymentMethod.vue';
import AddButton from '@/components/buttons/AddButton.vue';
import { mapGetters, mapActions } from 'vuex';
import { TrashIcon, PencilSquareIcon } from '@heroicons/vue/24/solid';
import PaginationButtons from '@/components/PaginationButtons.vue';
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";

export default {
  name: "MetodePembayaranTab",
  components: {
    AddButton, ModalPaymentMethod,
    TrashIcon, PencilSquareIcon,
    PaginationButtons, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell,
  },
  data() {
    return {
      modalShowPaymentMethod: false,
      isBlur: false,
      selectedPaymentMethod: null,
      currentPage: 1,
      totalPages: 1,
    }
  },
  props: {
    id: String
  },
  computed: {
    ...mapGetters('payment_methods', ['allPaymentMethods']),
  },
  created() {
    this.fetchPaymentMethods();
  },
  methods: {
    ...mapActions('payment_methods', ['deletePaymentMethodById']),
    async fetchPaymentMethods(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;
      try {
        const { pagination } = await this.$store.dispatch('payment_methods/fetchPaymentMethods', params);
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    showModal() {
      this.modalShowPaymentMethod = true;
      this.isBlur = true;
      this.selectedPaymentMethod = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowPaymentMethod = false;
        this.isBlur = false;
        this.fetchPaymentMethods();
      }, 200);
    },
    editPaymentMethod(paymentMethod) {
      this.selectedPaymentMethod = paymentMethod;
      this.modalShowPaymentMethod = true;
      this.isBlur = true;
    },
    async deletePaymentMethod(paymentMethod) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus metode pembayaran?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            await this.deletePaymentMethodById(paymentMethod.id);
            this.fetchPaymentMethods();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus metode pembayaran', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus metode pembayaran', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus metode pembayaran', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus metode pembayaran', life: 3000 });
        }
      });
    },
    isHutang(paymentMethod) {
      return paymentMethod?.name.toLowerCase() === "hutang";
    },
    isCash(paymentMethod) {
      return paymentMethod?.name.toLowerCase() === "cash";
    }
  },

}
</script>